import { PieChart } from '@mui/x-charts/PieChart';
import { legendClasses } from '@mui/x-charts/ChartsLegend';
import { config } from "../../config.js";

const PieChartData = (props) => {
    const data  = props.data;

    return (
        <PieChart
            colors={ config.colorArr }
            height={ data.options.height || 300 }
            width={ data.options.width || 300 }
            series={[
                {
                    data: data.recos,
                    innerRadius: data.options.innerRadius,
                    arcLabelMinAngle: 20,
                    arcLabel: data.options.arcLabel 
                    // valueFormatter,
                },
            ]}
            slotProps={{
                legend: {
                    direction: data.options.direction,
                    sx: {
                        gap: '16px',
                        // CSS-in-JS
                        [`.${legendClasses.mark}`]: {
                            height: 14,
                            width: 14,
                        },
                        // CSS class
                        ['.MuiChartsLegend-series']: {
                            gap: '8px',
                            color: '#98a2b3',
                        },
                    },
                },
            }
        }
      />
    )
}

export default PieChartData;